import script from "./OrgOrderReq.vue?vue&type=script&setup=true&lang=ts"
export * from "./OrgOrderReq.vue?vue&type=script&setup=true&lang=ts"

import "./OrgOrderReq.vue?vue&type=style&index=0&id=4b6528cc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4b6528cc"]])

export default __exports__